export default __webpack_public_path__ + "static/media/testimonial-image3.e52952e6.jpeg";